import { render, staticRenderFns } from "./SetStatus.vue?vue&type=template&id=4c0e4671&lang=pug"
import script from "./SetStatus.vue?vue&type=script&lang=js"
export * from "./SetStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports